import { rpc } from '@server/infrastructure/rpc'

import { getBearerToken } from '../../authentication'

/**
 * 만료 고객 프로모션 자격 조회
 */
export const getWelcomeBackPromotion = async (bearerToken?: string) => {
  const authorizationToken = bearerToken ?? (await getBearerToken())
  const response = await rpc.api.v1.users['welcomeback-promotion'].$get(
    {},
    { headers: { Authorization: `Bearer ${authorizationToken}` } },
  )

  if (!response.ok) {
    throw new Error(`Failed to fetch welcomeback promotion: ${response.status}`)
  }

  return response.json()
}

export type WelcomeBackPromotionResponse = Awaited<ReturnType<typeof getWelcomeBackPromotion>>
